import { Injectable } from '@angular/core';
import { IInscriptionResponse, IValidation, IValidationResponse } from '../models/inscription.model';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { HTTP_OPTIONS, ROUTES } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class InscriptionService {

  constructor(
    private httpClient: HttpClient,
    private messageService: MessageService
  ) {}
  
  /**
   * Add inscription
   * @param body 
   * @returns 
   */
  create(body: IValidation): Observable<IValidationResponse> {
    try {
      const response = this.httpClient.post<IValidationResponse>(`${ROUTES.inscription.send}`, body, HTTP_OPTIONS);
      return response;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Une erreur s\'est produite veuillez contacter le centre pour d\'emple information',
        closable: false,
      });
    }
  }

  /**
   * Get actif forfait
   * @returns 
   */
  getActif(): Observable<any> {
    try {
      const response = this.httpClient.get<any>(`${ROUTES.inscription.forfait}`);
      return response;
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        detail: 'Une erreur s\'est produite veuillez contacter le centre pour d\'emple information',
        closable: false,
      });
    }
  }

  // /**
  //  * Get actif forfait
  //  * @returns 
  //  */
  // getActif(type: string): Observable<IForfaitResponse> {
  //   return this.httpClient.get<IForfaitResponse>(`${API_URL}/personne/forfait/get-actif-by-type-forfait/${type}`)
  //   .pipe(tap((response: IForfaitResponse) => {
  //     console.log(response);
  //   }, (err: any) => {
  //     console.log('error');
  //   })
  //   );
  // }
}
